import type { PropertiesTableProps } from '../../shared/types'
import { TypographyProperties } from '../typography/TypographyDocs'

export const SpanProperties: PropertiesTableProps = {
  ...TypographyProperties,
}
